import type { FeatherIconComponent } from '@klausapp/ui-kit/icons'
import type { CustomField } from '@zendesk/zqa-services/filters'

import type { CalibrationFilterParams } from './calibration/types'

export interface SortedResponse {
  sort: {
    field: string
    asc: boolean
  }
}

export interface PaginatedResponse {
  pagination: {
    page: number
    pageSize: number
    total: number
  }
}

/**
 * Possible duration steps to query by
 */
export enum FilterTimeStep {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/**
 * Possible duration steps to query by
 */
export enum FilterTimeStepKey {
  Day = 'days',
  Week = 'weeks',
  Month = 'months',
  Year = 'years',
}

/**
 * Time presets for the picker
 */
export enum FilterTimePeriod {
  ThisWeek = 'this_week',
  LastWeek = 'last_week',
  Week = 'week',
  ThisMonth = 'this_month',
  LastMonth = 'last_month',
  Month = 'month',
  Custom = 'custom',
  ThisYear = 'this_year',
  LastYear = 'last_year',
  Last = 'past',
}

export interface Member {
  id: number
  name: string
  email: string
  avatar?: string | null
  icon?: FeatherIconComponent
}

export interface HelpdeskCustomFieldFilter {
  externalId: CustomField['externalId']
  values: string[]
}

export interface CoreFilterParams {
  workspaceIds: number[]
  timePeriod: FilterTimePeriod
  fromDate?: string
  toDate?: string
  userGroups: string[]
  value?: number
  unit?: FilterTimeStep
}
export interface FilterParams extends CoreFilterParams {
  step?: FilterTimeStep
  decimals: number
  userIds: number[]
  commentTags: string[]
  sort?: string
  sortAsc?: boolean
  page?: number
  pageSize?: number
  categoryId: string
}

export interface DashboardFilterParams extends FilterParams, CalibrationFilterParams {}

export type FilterUserActionParams = Pick<FilterParams, 'sort' | 'sortAsc' | 'page' | 'pageSize'>

export type FilterTimeParams = Pick<FilterParams, 'timePeriod' | 'fromDate' | 'toDate' | 'value' | 'unit'>

export interface Reviewer {
  id: string
  name: string
  avatar: string
}
